module.exports = __webpack_public_path__ + "img/Indonesia-4-hover.00704560.jpg";